<template>
  <div>
    <div class="d-flex flex-column" style="width:100%;" v-if="!showMobileView">
      <filter-bar
        name="keys"
        :filter="_keysFilter"
        :searchTypes="searchTypes"
      />
      <div class="d-flex justify-end">
        <v-card
          class="mr-4 mt-4 d-flex align-center"
          height="40"
          width="168"
          color="secondary"
          v-if="!showMobileView"
          style="color:white; font-weight:bold;"
          @click="_setCreateKey(true)"
        >
          <v-row>
            <v-spacer />
            <v-spacer />
            <v-row class="d-flex justify-space-around" id="new-digital-key">
              <v-icon color="white">mdi-plus</v-icon>
              New Digital Key
            </v-row>
            <v-spacer />
            <v-spacer />
          </v-row>
        </v-card>
      </div>
    </div>
    <v-card-title class="text-center" v-if="showMobileView">
      <v-card-text
        class="primary--text text-subtitle-1 font-weight-medium py-2"
      >
        DIGITAL KEYS
      </v-card-text>
    </v-card-title>
    <v-btn
      color="primary"
      style="width: calc(100vw - 32px)"
      class="mx-4 text-subtitle-1 font-weight-medium mb-4"
      :class="textStyle"
      height="60"
      v-if="showMobileView && isAdmin"
      @click="_setCreateKey(true)"
    >
      <v-icon small>
        mdi-plus
      </v-icon>
      New Digital Key
    </v-btn>
    <div class="d-flex ml-3" v-if="showMobileView">
      <search :searchTypes="searchTypes" />
      <v-card
        class="mr-4 mt-6 d-flex align-center flex-shrink-0"
        height="40"
        width="40"
        color="black"
        @click="_setFilter(true)"
      >
        <v-row>
          <v-spacer />
          <v-col>
            <v-icon color="white">mdi-filter</v-icon>
          </v-col>
          <v-spacer />
        </v-row>
      </v-card>
    </div>
    <tables class="mt-n2" />
    <create-key />
    <filters />
  </div>
</template>
<script>
import { mapActions, mapMutations, mapGetters } from 'vuex';
import Filters from '@/components/filter/Filters';
import Search from '@/components/app/Search';
import Tables from '@/components/key-codes/Table';
import CreateKey from '@/components/key-codes/CreateKey';
import FilterBar from '@/components/app/FilterBar.vue';
import { MobileView, UserPermissions } from '@/mixins';

export default {
  components: {
    Search,
    Tables,
    CreateKey,
    Filters,
    FilterBar,
  },
  mixins: [MobileView, UserPermissions],
  computed: {
    ...mapGetters({
      _keysFilter: 'filters/getFilter',
    }),
  },
  data() {
    return {
      searchTypes: ['Code', 'Email', 'Phone Number'],
    };
  },
  methods: {
    ...mapActions({
      _acquireData: 'digitalKeys/acquireData',
    }),
    ...mapMutations({
      _setCreateKey: 'digitalKeys/setCreateKey',
      _setFilter: 'filters/setFilters',
    }),
  },
  mounted() {
    this._acquireData();
  },
};
</script>
